function parseSrc(src) {
  const link = document.createElement('a');
  link.href = src;
  return {
    protocol: link.protocol, href: link.href, path: link.pathname, search: link.search, hash: link.hash,
  };
}

function isSrcOnpageContent(src) {
  const uri = parseSrc(src);
  const uriWithoutHash = uri.href.substr(0, uri.href.length - uri.hash.length);
  const currentUri = window.location.href.replace(/#.*$/, '');
  return uri.hash && uriWithoutHash === currentUri;
}

function generateId(prefix, hashArguments) {
  const string = JSON.stringify(hashArguments);
  let hash = 0;
  if (string.length === 0) {
    return hash;
  }
  for (let i = 0; i < string.length; i++) {
    const char = string.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash &= hash; // Convert to 32bit integer
  }
  return `${prefix}-${hash}`;
}

function createPostForm(action, body, target) {
  const form = document.createElement('form');
  const input = document.createElement('input');

  form.action = action;
  form.method = 'POST';
  form.target = target;

  body.forEach(([name, value]) => {
    input.name = name;
    input.value = value.toString();
    form.appendChild(input.cloneNode());
  });

  form.style.visibility = 'hidden';
  return form;
}

function getOpenerFromEvent(event) {
  const path = event.composedPath();
  for (let i = 0; i < path.indexOf(document.body); i++) {
    const target = path[i];
    if (target.hasAttribute && target.hasAttribute('target') && target !== document.body) {
      return target;
    }
  }
}

function getBodyFromOpener(opener, idHash) {
  if (opener.hasAttribute('data-modal-post')) {
    const modalPostArguments = opener.getAttribute('data-modal-post');
    idHash.method = 'POST';
    idHash.body = modalPostArguments;
    const body = [];
    (new URL(`http://localhost/?${modalPostArguments}`)).searchParams.forEach((value, name) => {
      body.push([name, value]);
    });
    return [body, idHash];
  }
  return [null, idHash];
}

function createModal(modalId, idHash, src, method, body) {
  const fitModal = document.createElement('fit-modal');
  const iframe = document.createElement('iframe');
  const iframeId = generateId('iframe', idHash);

  fitModal.id = modalId;
  iframe.name = iframeId;

  document.body.appendChild(fitModal);

  if (isSrcOnpageContent(src)) {
    const content = document.querySelector(src);
    const contentNodes = content instanceof HTMLTemplateElement ? document.importNode(content.content, true).children : content.childNodes;
    if (content.title) {
      fitModal.title = content.title;
    }

    Array.from(contentNodes).forEach(function (element) {
      if (element instanceof HTMLElement && element.hasAttribute('dialog-title')) {
        fitModal.title = element.textContent;
        return;
      }

      fitModal.appendChild(element);
    });

  } else if (body && method === 'POST') {
    const form = createPostForm(src, body, iframeId);
    // disable checkOrigin to allow iframe resizing #3916
    iframe.setAttribute('fit-iframe', JSON.stringify({checkOrigin: false}));
    fitModal.appendChild(form);
    fitModal.appendChild(iframe);
    form.submit();
    form.remove();
  } else if (method === 'GET') {
    iframe.src = src;
    fitModal.appendChild(iframe);
  }

  return fitModal;
}

function openModal(idHash, src, method, body) {
  try {
    if (window.parent && window.parent !== window && window.parent.origin === window.origin && window.parentIFrame !== undefined) {
      // We're in an iframe
      window.parentIFrame.sendMessage({type: 'openModal', idHash, src, method, body});
      return;
    }
  } catch(e) {
    // catch error if page is included as iframe
  }

  const modalId = generateId('fit-modal', idHash);
  const modal = document.getElementById(modalId) || createModal(modalId, idHash, src, method, body);
  setTimeout(() => { modal.open(); });
}

export const openModalOnFitModalTargetClick = (event) => {
  if (event.metaKey || event.ctrlKey) {
    return;
  }

  const opener = getOpenerFromEvent(event);
  if (!(opener instanceof HTMLElement || opener instanceof SVGElement)
      || opener instanceof HTMLFormElement) {
    return;
  }

  if (opener.getAttribute('target') === 'fit-modal') {
    const href = opener.getAttribute('href');
    let src = (href.indexOf('?') !== -1 ? `${href.split('?')[0]}?` + 'fit-ajax-modal=1' + `&${href.split('?')[1]}` : (href.indexOf('#') !== -1 ? `${href.split('#')[0]}?` + 'fit-ajax-modal=1' + `#${href.split('#')[1]}` : `${href}?` + 'fit-ajax-modal=1'));;

    // do not append fit-ajax-modal on anchor links
    if (true === /^#/.test(href)) {
      src = href;
    }

    const [body, idHash] = getBodyFromOpener(opener, { src });

    openModal(idHash, src, body ? 'POST' : 'GET', body);

    event.preventDefault();
    event.stopPropagation();
  }
};

export const openModalOnNestedModalOpen = ({idHash, src, method, body}) => {
  openModal(idHash, src, method, body);
};
